import { HeaderContainer } from "../../components/Layout/HeaderContainer/HeaderContainer";
import { PageContainer } from "../../components/Layout/PageContainer/PageContainer";

import { SettingsContent } from "../../components/Pages/Settings/Main/SettingsContent/SettingsContent";
import { UserPreferencesContextProvider } from "../../context/UserPreferencesContext";
import { AccessHeaderLogo } from "../../components/Shared/Buttons/AccessHeaderLogo";
import { MenuButton } from "../../components/Shared/Buttons/MenuButton";
import { PageTitle } from "../../components/Shared/Headings/PageTitle";

export const SettingsPage = () => {
  return (
    <UserPreferencesContextProvider>
      <PageContainer
        header={{
          content: (
            <HeaderContainer
              start={
                <>
                  <MenuButton />
                  <AccessHeaderLogo />
                </>
              }
              middle={<PageTitle title="Settings" />}
              end={<></>}
              featureSentimentName="Settings"
            />
          )
        }}
        main={{
          content: <SettingsContent />
        }}
      />
    </UserPreferencesContextProvider>
  );
};
